import { FlexBox } from '@ardoq/layout';
import {
  FilterDataInteractiveRowViewState,
  InventoryInteractiveTopRowCommands,
} from './types';
import { Text } from '@ardoq/typography';
import { pluralizeWithCount } from '@ardoq/common-helpers';
import { type I18nLocale, t } from '@ardoq/i18n';
import { SearchColumnGroup } from './SearchColumnGroup';
import { HierarchyViewControls } from './HierarchyViewControls';
import { TableControlsInteractiveRow } from './TableControlsInteractiveRow';

type FilterDataInteractiveRowProps = {
  state: FilterDataInteractiveRowViewState;
  commands: InventoryInteractiveTopRowCommands;
  i18nLocale: I18nLocale;
};

export const FilterDataInteractiveRow = ({
  state,
  commands,
  i18nLocale,
}: FilterDataInteractiveRowProps) => {
  return (
    <TableControlsInteractiveRow i18nLocale={i18nLocale}>
      <FlexBox gap="xsmall" align="center">
        <SearchColumnGroup
          state={state}
          commands={commands}
          i18nLocale={i18nLocale}
        />
        {state.showHierarchyViewControls && (
          <HierarchyViewControls
            isHierarchyEnabled={state.isHierarchyEnabled}
            datasourceSelection={state.datasourceSelection}
            onToggleHierarchy={commands.toggleHierarchy}
            onBackToComponentType={commands.goBackToComponentType}
            i18nLocale={i18nLocale}
          />
        )}
      </FlexBox>

      <FlexBox align="center">
        <Text variant="text2" color="textSubtle">
          {t(
            i18nLocale,
            'inventory:interactiveRow.componentCount',
            { count: state.totalNumberOfMatchingRows },
            pluralizeWithCount('component', state.totalNumberOfMatchingRows)
          )}
        </Text>
      </FlexBox>
    </TableControlsInteractiveRow>
  );
};
